module.exports = __webpack_public_path__ + "posture/static/img/head_sideway_normal.4716ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/head_sideway_normal.png
// module id = uSsQ
// module chunks = 1